import axios from '@/libs/api.request'

export const createQuote = (data) => {
  return axios.request({
    url: `quotes`,
    method: 'post',
    data
  })
}

export const getQuotes = (query) => {
  return axios.request({
    url: `quotes`,
    params: query,
    method: 'get'
  })
}

export const updateQuote = (id, data) => {
  return axios.request({
    url: `quotes/${id}`,
    method: 'put',
    data
  })
}

export const getQuote = (quoteId) => {
  return axios.request({
    url: `/quotes/${quoteId}?includes[]=customer&includes[]=externalObjectRelation`,
    method: 'get'
  })
}

export const deleteQuote = (quoteId) => {
  return axios.request({
    url: `/quotes/${quoteId}`,
    method: 'delete'
  })
}

export const searchQuote = (query) => {
  return axios.request({
    url: `/search/quote`,
    method: 'get',
    params: query
  })
}

export const getQuoteBom = (quoteId) => {
  return axios.request({
    url: `/quotes/${quoteId}/boms`,
    method: 'get'
  })
}

export const updateQuoteNumber = (quoteId, quoteNumber) => {
  const data = { number: quoteNumber }
  return axios.request({
    url: `/quotes/${quoteId}/update-quote-number`,
    method: 'post',
    data
  })
}

export const getQuoteRelated = (quoteId, type) => {
  return axios.request({
    url: `/quotes/${quoteId}/related/${type}`,
    method: 'get'
  })
}

export const associateQuoteRelated = (quoteId, type, typeId) => {
  return axios.request({
    url: `/quotes/${quoteId}/related/${type}`,
    method: 'post',
    data: { id: typeId }
  })
}

export const sendQuoteToHubSpot = (quoteId, data) => {
  return axios.request({
    url: `/quotes/${quoteId}/sync-to-hubspot`,
    method: 'post',
    data: data
  })
}

export const getQuoteTemplates = (data) => {
  let url = data?.source === 'hubspot'
    ? `/integration/hubspot/quote-templates?limit=${data.limit}`
    : '/quotes/templates'
  return axios.request({
    url: url,
    method: 'get'
  })
}

export const getQuoteActivitiesTimeline = (quoteId) => {
  return axios.request({
    url: `quotes/${quoteId}/activities/timeline`,
    method: 'get'
  })
}

export const sendReminder = () => {
  return axios.request({
    url: `workflow/dingtalk`,
    method: 'post',
    data: data
  })
}
